function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6 0c2.9 0 5.25 2.35 5.25 5.25 0 1.823-1.475 4.48-4.41 8.067l-.392.474a.583.583 0 01-.896 0C2.356 9.962.75 7.152.75 5.25.75 2.35 3.1 0 6 0zm0 2.917a2.333 2.333 0 100 4.666 2.333 2.333 0 000-4.666z",
  fill: "#333",
  fillRule: "evenodd"
});

function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgLocation;